import React, { useState, useEffect } from "react"

const MetabaseDashboardWidget = ({ fleetId }) => {
  const [embedUrl, setEmbedUrl] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchEmbedUrl = async () => {
      try {
        const response = await fetch(`${window.location.origin}/api/v6/generate_metabase_url`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            fleetId: fleetId,
            startDate: "2025-01-01",
            endDate: "2025-12-31"
          })
        })

        if (!response.ok) {
          throw new Error("Failed to fetch embed URL")
        }

        const data = await response.json()
        if (data.embedUrl) {
          setEmbedUrl(data.embedUrl)
        } else {
          console.error("Failed to get embed URL")
        }
      } catch (error) {
        console.error("Error fetching embed URL:", error)
      } finally {
        setLoading(false)
      }
    }

    fetchEmbedUrl()
  }, [fleetId])

  if (loading) {
    return <div>Loading dashboard...</div>
  }

  return (
    <div>
      {embedUrl ? (
        <iframe src={embedUrl} width="100%" height="600" title="Metabase Dashboard" />
      ) : (
        <div>Error loading dashboard</div>
      )}
    </div>
  )
}

export default MetabaseDashboardWidget
